<div class="ud certification-container" aria-labelledby="certification-title">
  <div class="ud__header">
    <h2 class="ud__title" id="certification-title">
      {{
      data
      ? "Editar Certificación"
      : "Agregar Certificación a la Lista"
      }}
    </h2>
    <button mat-icon-button type="button" (click)="cancelClick()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="ud__body">
    <div class="ud__field">
      <label for="name">Nombre de la certificación*</label>
      <input id="name" type="text" [(ngModel)]="name" (input)="validateSpecialCharacters($event)"
        placeholder="Nombre de la certificación" maxlength="50" required />
    </div>
    <div class="ud__field">
      <label for="issuingAuthority">Quién la otorga*</label>
      <input id="issuingAuthority" type="text" [(ngModel)]="issuingAuthority"
        (input)="validateSpecialCharacters($event)" placeholder="Entidad que otorga la certificación" maxlength="50"
        required />
    </div>
    <div class="ud__field">
      <label for="duration">Cantidad de horas*</label>
      <input id="duration" type="number" (input)="validateDuration($event)" (keydown)="validateOnlyNumbers($event)"
        [(ngModel)]="duration" placeholder="Duración en horas" maxlength="5" required />
    </div>
    <div class="ud__field">
      <label for="textArea">Descripción*</label>
      <textarea id="textArea" [(ngModel)]="description" placeholder="Ingrese una descripción para la certificación"
        cols="30" maxlength="500" rows="4" required></textarea>
    </div>
  </div>
  <div class="ud__actions">
    <button id="cancelButton" type="button" class="ind-button-lite" (click)="cancelClick()">Cancelar</button>
    <button id="saveButton" type="button" class="ind-button" (click)="onSubmit()">Guardar</button>
  </div>
</div>
